module.exports = __webpack_public_path__ + "img/checkmark.2f8c85a6.svg";